<template>
  <div>
    <a-form class="simiot-nested-search-form" :form="form" @submit="handleSearch">
      <a-row :gutter="24">
        <a-col :span="6">
          <a-form-item label="运营商种类">
            <a-select
              v-decorator="['carrier_type']"
              allow-clear
              @change="changeCarrier"
            >
              <a-select-option
                v-for="option in carrierTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="流量场景">
            <a-select
              v-decorator="['traffic_scene_id']"
              allow-clear
              show-search
              option-filter-prop="children"
              :disabled="!carrierType"
              :loading="loadingTrafficSceneOptions"
            >
              <a-select-option
                v-for="option in trafficSceneOptions"
                :key="option.id"
                :value="option.id"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="用户业务模式">
            <a-select
              v-decorator="['user_business_type']"
              allow-clear
            >
              <a-select-option
                v-for="option in userBusinessTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item label="套餐名称">
            <a-input
              v-decorator="['name', {
                normalize: this.$lodash.trim
              }]"
              allow-clear
            />
          </a-form-item>
        </a-col>

        <a-col :span="6">
          <a-form-item>
            <a-space>
              <a-button type="primary" html-type="submit">
                搜索
              </a-button>
              <a-button @click="handleReset">
                刷新
              </a-button>
            </a-space>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>
<script>
import { findUserBusinessTypeOptions, findCarrierTypeOptions } from '@/api/common_options'
import { findTrafficSceneOptions } from '@/api/traffic_scene'

export default {
  name: 'ImportAgentsProductSearch',
  data() {
    return {
      expand: false,
      userBusinessTypeOptions: findUserBusinessTypeOptions(),
      carrierTypeOptions: findCarrierTypeOptions(),
      carrierType: undefined,
      trafficSceneOptions: [],
      loadingTrafficSceneOptions: false,
      form: this.$form.createForm(this, { name: 'import_products_search' })
    }
  },
  methods: {
    changeCarrier(value) {
      this.carrierType = value
      this.trafficSceneOptions = []
      this.form.setFieldsValue({ traffic_scene_id: undefined })
      if (value) {
        this.fetchTrafficSceneOptions(value)
      }
    },

    fetchTrafficSceneOptions(carrierType) {
      this.loadingTrafficSceneOptions = true
      findTrafficSceneOptions({ carrier_type: carrierType }).then((res) => {
        if (res.code === 0 && this.carrierType === carrierType) {
          this.trafficSceneOptions = res.data || []
        }
        this.loadingTrafficSceneOptions = false
      }).catch(() => {
        this.loadingTrafficSceneOptions = false
      })
    },

    handleSearch(e) {
      e.preventDefault()
      this.$emit('submit', this.form.getFieldsValue())
    },

    handleReset() {
      this.form.resetFields()
      this.carrierType = undefined
      this.trafficSceneOptions = []
      this.$emit('submit', {})
    }
  }
}
</script>
